import React from 'react';
import { useIntl } from 'react-intl';

const CollectedDetailsListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>
        {intl.formatMessage({ defaultMessage: 'Name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Email' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Type' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Time' })}
      </th>
    </tr>
  );
};

export default CollectedDetailsListHeader;
